import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { convertStringToBoolean } from '@core/_utils/tools.utils';
import * as delegateTools from './../delegate.tools';
import { RequestTools } from '@service/request.tools';
import { CheckTools } from '@service/check.tools';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-delegate',
    templateUrl: './edit-delegate.component.html',
    styleUrls: ['./edit-delegate.component.scss'],
})
export class EditDelegateComponent implements OnInit {
    public selectedDelegate: any;    
    public resultResult: any[];

    public errorMessage = '';
    public errorLoaderDialog = false;
   
    @Input()
    public item: any;

    @Input()
    public fromUser = [];

    @Input()
    public toUser = [];

    @Input()
    public delegate: any;
    
    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    constructor(
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private requestTools: RequestTools,
        private checkTools: CheckTools,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.selectedDelegate = {};
    }

    ngOnInit() {
        this.getResult(this.item.id);
        this.commonService.checkReset();
    }

    private getResult(id) {
        this.selectedDelegate.useDelegate = convertStringToBoolean(this.delegate.UseDelegate);
        this.selectedDelegate.dateBegin = new Date(this.delegate.DateBegin);
        this.selectedDelegate.dateEnd = new Date(this.delegate.DateEnd);
        this.selectedDelegate.userDelegated = this.delegate.UserDelegated;
        this.selectedDelegate.userLogin = this.delegate.UserLogin;
        this.selectedDelegate.fromLogin = this.delegate.FromLogin;
        this.selectedDelegate.delegatedLogin = this.delegate.DelegatedLogin;
    }

    public async validate(result) {
        let wRes: any;
        wRes = await delegateTools.updateDelegate(result, this);

        this.onValidate.emit({
            index: this.item.index,
            id: this.item.id,
            data: wRes.data.UserList,
        });
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
